(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-featured-reviews';

  function initSection(section) {
    if (!section || section.dataset.odditInitialized === 'true') return;
    section.dataset.odditInitialized = 'true';

    var track = section.querySelector('.oddit-section-featured-reviews__track');
    var prevBtn = section.querySelector('.oddit-section-featured-reviews__nav-btn--prev');
    var nextBtn = section.querySelector('.oddit-section-featured-reviews__nav-btn--next');
    var pagination = section.querySelector('.oddit-section-featured-reviews__pagination');
    var dots = section.querySelectorAll('.oddit-section-featured-reviews__dot');

    if (!track) return;

    // One logical slide per pair. On mobile the .pair is the visible flex item;
    // on desktop .pair is display:contents, so the pair's first .review is the
    // start of that logical slide (review + photo).
    function getSlides() {
      var pairs = track.querySelectorAll('.oddit-section-featured-reviews__pair');
      var slides = [];
      Array.prototype.forEach.call(pairs, function (pair) {
        var cs = window.getComputedStyle(pair);
        if (cs.display === 'contents') {
          var review = pair.querySelector('.oddit-section-featured-reviews__review');
          slides.push(review || pair.firstElementChild);
        } else {
          slides.push(pair);
        }
      });
      return slides;
    }

    function getGutter() {
      var cs = window.getComputedStyle(track);
      return parseFloat(cs.scrollPaddingLeft) || parseFloat(cs.paddingLeft) || 0;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    // scrollLeft that parks `el` at the gutter (under the heading).
    function slideTarget(el) {
      var trackRect = track.getBoundingClientRect();
      var elRect = el.getBoundingClientRect();
      var target = track.scrollLeft + (elRect.left - trackRect.left) - getGutter();
      return Math.max(0, Math.min(target, maxScroll()));
    }

    function currentIndex() {
      var slides = getSlides();
      if (slides.length === 0) return 0;
      // Snapped to the very end → always the last slide (end padding means the
      // last slide never reaches the gutter, so distance math would miss it).
      if (track.scrollLeft >= maxScroll() - 1) return slides.length - 1;
      var sl = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (el, i) {
        var dist = Math.abs(slideTarget(el) - sl);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    function goToIndex(index) {
      var slides = getSlides();
      if (slides.length === 0) return;
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;
      track.scrollTo({ left: slideTarget(slides[index]), behavior: 'smooth' });
    }

    // Hide dots whose clamped scroll target duplicates an earlier dot's target,
    // and hide the entire pagination when only one (or zero) reachable target
    // remains. Without this, blocks that have no paired photo (and therefore a
    // narrower per-slide footprint) render N dots but only ~N - slidesPerView + 1
    // of them actually move the carousel — the rest all clamp to maxScroll.
    function updatePagination() {
      var slides = getSlides();
      var ms = maxScroll();
      var seen = {};
      var visible = 0;
      for (var i = 0; i < dots.length; i++) {
        if (i >= slides.length) {
          dots[i].hidden = true;
          continue;
        }
        // slideTarget already clamps to [0, maxScroll], so duplicate keys here
        // represent dots that would scroll to the same place.
        var key = Math.round(slideTarget(slides[i]));
        if (key in seen) {
          dots[i].hidden = true;
        } else {
          seen[key] = i;
          dots[i].hidden = false;
          visible++;
        }
      }
      if (pagination) pagination.hidden = visible <= 1 || ms <= 0;
    }

    function setActive(activeIndex) {
      var slides = getSlides();
      // The active slide may correspond to a dot that's hidden because an
      // earlier dot shares the same clamped target. In that case the visible
      // representative is the first dot whose target matches.
      var targetActive = (activeIndex >= 0 && activeIndex < slides.length)
        ? Math.round(slideTarget(slides[activeIndex]))
        : null;
      var winnerIdx = -1;
      if (targetActive !== null) {
        for (var k = 0; k < dots.length && k < slides.length; k++) {
          if (dots[k].hidden) continue;
          if (Math.round(slideTarget(slides[k])) === targetActive) {
            winnerIdx = k;
            break;
          }
        }
      }
      for (var i = 0; i < dots.length; i++) {
        var active = i === winnerIdx;
        dots[i].classList.toggle('oddit-section-featured-reviews__dot--active', active);
        if (active) {
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll() - 1;
    }

    function sync() {
      updatePagination();
      setActive(currentIndex());
      updateNavState();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToIndex(currentIndex() - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToIndex(currentIndex() + 1);
      });
    }

    Array.prototype.forEach.call(dots, function (dot, index) {
      dot.addEventListener('click', function () {
        goToIndex(index);
      });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    sync();
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
